import {useCommerceAPIContext} from '../../contexts'
import {CommerceAPI} from 'commerce-api'

export const useCommerceAPI = (): CommerceAPI => useCommerceAPIContext()
